import React, { useEffect, useRef } from 'react';
import {Animated, Easing, StyleSheet, View} from 'react-native';
import {LoaderCircle} from "lucide-react-native";
import {ThemeType} from "@/theming/baseTheme";
import {useCurrentTheme} from "@/theming/useCurrentTheme";

export function LoadSpinner({size = 48}: {size?: number}) {
    const {theme} = useCurrentTheme();
    const styles = createStyles(theme);
    const spinAnim = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        Animated.loop(
            Animated.timing(spinAnim, {
                toValue: 1,
                duration: 1000,
                useNativeDriver: true, // Important for performance
                easing: Easing.linear,
            })
        ).start();
    }, [spinAnim]);

    const spin = spinAnim.interpolate({
        inputRange: [0, 1],
        outputRange: ['0deg', '360deg'],
    });

    return (
        <View style={styles.container}>
            <Animated.View style={{ transform: [{ rotate: spin }] }}>
                <LoaderCircle size={size} color={theme.colors.primary} />
            </Animated.View>
        </View>
    );
}

const createStyles = (theme: ThemeType) => StyleSheet.create({
    container: {
        justifyContent: 'center',
        alignItems: 'center',
    }
});
